<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">


            <div class="card" v-if="is('Super Admin') || is('Admin')">
              <div class="card-header">
                <h3 class="card-title">Customer List</h3>
                <input style="margin-left:2%" type="text" v-model="searchText" name="name" placeholder="Search.." @keyup="search"  autocomplete="off">
                <div class="card-tools">

                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Add New
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Sale Amount</th>
                      <th>Points</th>

                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="item in items.data" :key="item.id">

                      <td>{{item.id}}</td>
                      <td ><a href="#" @click.prevent="$router.push(`/customer/sales/${item.id}`)">{{item.name}}</a></td>
                      <td>{{ Number(item.sales.reduce((total, obj) => parseFloat(obj.grand_total) + total,0)).toFixed(2) }}</td>
                      <td><a href="#" @click.prevent="$router.push(`/customer/points/view/${item.id}`)">{{item.points}}</a></td>

                      <td>

                        <a href="#" @click="editModal(item)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                         /
                        <a href="#" @click="RemoveItem(item.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                <select  @change="load()"  v-model="numberOfItems">
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="All">ALL</option>
                  </select>
                <pagination :data="items" :limit="3" @pagination-change-page="page => getResults(page,searchText )"></pagination>
                  <!-- <pagination :data="items" :limit="3" @pagination-change-page="getResults"></pagination> -->
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!is('Super Admin') && !is('Admin')">
            <not-found></not-found>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Create New Customer</h5>
                    <h5 class="modal-title" v-show="editmode">Update Customer</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? update() : create()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Name</label>
                            <input v-model="form.name" type="text"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>

                        <div class="form-group">
                            <label>Points Option</label>
                            <select class="form-control" v-model="form.no_points">
                              <option value="0">Yes</option>
                              <option value="1">No</option>
                            </select>
                            <has-error :form="form" field="customer_group_id"></has-error>
                        </div>
                        <!--<div class="form-group">
                            <label>Customer Group</label>
                            <select class="form-control" v-model="form.customer_group_id">
                              <option
                                  v-for="(cat,index) in customerGroups" :key="index"
                                  :value="index"
                                  :selected="index == form.customer_group_id">{{ cat }}</option>
                            </select>
                            <has-error :form="form" field="customer_group_id"></has-error>
                        </div>-->

                        <div class="form-group">
                            <label>Phone</label>
                            <input v-model="form.phone" type="text"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>

                        <div class="form-group">
                            <label>Address</label>
                            <input v-model="form.address" type="text"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>



                        <div class="form-group">
                            <label>Area</label>
                            <input v-model="form.area" type="text"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>District</label>
                            <input v-model="form.district" type="text"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>PPO Number</label>
                            <input v-model="form.ppo" type="text"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Monthly Limit</label>
                            <input v-model="form.monthly_limit" type="text"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Yearly Limit</label>
                            <input v-model="form.yearly_limit" type="text"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>


                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Update</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Create</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {

        data () {
            return {
              searchText:null,
              numberOfItems: 10,
                customerGroups: null,
                editmode: false,
                items : {},
                extras: [],
                form: new Form({
                    id : '',
                    name: '',
        customer_group_id: '',
        address: '',
        area: '',
        ppo: '',
        monthly_limit: '',
        yearly_limit: '',
        tax_number: '',
        district: '',
        phone: '',
                })
            }
        },
        methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
          search()
          {
            if(this.searchText == '')
            {
              this.load();
            }
            else
            {
              axios.get("/api/customer/list/search/"+this.searchText).then(
                ({ data }) => (this.items = data.data)
              );
            }


          },

            getResults(page = 1,searchText=null) {

                  this.$Progress.start();

                  axios.get('/api/customer?page=' + page + '&searchText=' + searchText + '&numberOfItems='  +this.numberOfItems).then(({ data }) => (this.items = data.data));
                  this.scrollToTop();
                  this.$Progress.finish();
            },
            addExtra()
            {
              this.form.extras.push({ field: '', value: '' });
            },
            update(){
                this.$Progress.start();
                this.form.put('/api/customer/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.load();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(item){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(item);
            },

            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');

            },

            load(){
                this.getResults();
                    // axios.get("/api/customer").then(({ data }) => (this.items = data.data));

            },

            create(){

                this.form.post('/api/customer')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.load();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            },
            loadCustomerGroups(){
                axios.get("/api/customer/group/list").then(({ data }) => (this.customerGroups = data.data));
            },
             RemoveItem(id)
        {

              Swal.fire({
                  title: 'Are you sure?',
                  text: "You won't be able to revert this!",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Yes, delete it!'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                              this.form.delete('/api/customer/'+id).then(()=>{
                                      Swal.fire(
                                      'Deleted!',
                                      'Your file has been deleted.',
                                      'success'
                                      );
                                  // Fire.$emit('AfterCreate');
                                  this.load();
                              }).catch((data)=> {
                                  Swal.fire("Failed!", data.message, "warning");
                              });
                        }
                  })
        }

        },
        mounted() {
            window.scrollTo(0, 0)
        },
        created() {

            this.$Progress.start();
            this.load();
            this.loadCustomerGroups();
            this.$Progress.finish();
        },

    }
</script>
